import { APIProvider, Map, useMap, Marker } from "@vis.gl/react-google-maps";
import { useEffect } from "react";

import Constants from "../../../utils/Constants";

const LocationMap = ({
  lat,
  lng,
  useMapMarker,
  zoom = 10,
  height = 200,
}: {
  lat: number;
  lng: number;
  useMapMarker: boolean;
  zoom?: number;
  height?: number;
}) => {
  return (
    <div style={{ height: height, minHeight: 200, width: "100%" }}>
      <APIProvider apiKey={Constants.GOOGLE_MAPS_KEY}>
        <Map
          gestureHandling={"greedy"}
          defaultZoom={zoom}
          defaultCenter={{
            lat: lat,
            lng: lng,
          }}
          disableDefaultUI={true}
        >
          {useMapMarker && <Marker position={{ lat: lat, lng: lng }} />}
          <MapHandler zoom={zoom} lng={lng} lat={lat} />
        </Map>
      </APIProvider>
    </div>
  );
};

/**
 * Component which access to the Google Maps API to modify the Map instance (Modifies the lat,lng and zoom when changes).
 *
 * Need to be used inside of the Map component because the useMap hook relies on the context provided of the Map component.
 */
const MapHandler = ({ zoom, lng, lat }: any) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    map.setCenter({ lat: lat, lng: lng });
    map.setZoom(zoom);
  }, [map, zoom, lng, lat]);

  // No need to render anything.
  return null;
};

export default LocationMap;
